import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-global-line',
    title: '官方入口直达',
    description: '提供 91.cc 官方入口的最新信息，支持多种安全访问方式，确保您随时稳定连接平台。',
    href: '/article/official-entry-guide',
  },
  {
    icon: 'ri-guide-line',
    title: '完整使用指南',
    description: '从注册到高级功能，涵盖 91.cc 平台使用的方方面面，帮助新老用户快速上手。',
    href: '/category/guide',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全访问保障',
    description: '提供账户安全保护、防钓鱼指南和安全访问建议，全方位守护您的使用安全。',
    href: '/article/security-tips',
  },
  {
    icon: 'ri-notification-3-line',
    title: '最新动态追踪',
    description: '实时更新 91.cc 平台的最新公告、功能优化和版本更新信息，让您掌握第一手资讯。',
    href: '/category/news',
  },
  {
    icon: 'ri-question-answer-line',
    title: '常见问题解答',
    description: '整理汇总用户最常遇到的问题及解决方案，快速解答您的疑惑，节省查找时间。',
    href: '/category/faq',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝体验',
    description: '支持网页端和移动客户端访问，数据同步无缝衔接，随时随地享受完整服务。',
    href: '/article/mobile-app-guide',
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20" aria-labelledby="features-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 id="features-heading" className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            平台核心功能与服务
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            一站式了解 91.cc 的全部核心功能，帮助您高效使用平台服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <Link
              key={feature.title}
              to={feature.href}
              className="group bg-background-50 rounded-lg p-5 md:p-6 hover:bg-background-50 transition-colors border border-background-200/60 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold font-heading text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}